// src/components/ui/button.js
export const Button = ({ children, className, ...props }) => {
    return (
      <button className={`btn ${className}`} {...props}>
        {children}
      </button>
    );
  };
  